import { Star, ExternalLink, ShieldQuestion } from "lucide-react";
import { company } from "@/config/content";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

// Reviews section — placeholder only. No fake reviews per requirements.
export function Reviews() {
  const { t } = useLang();
  return (
    <section id="recensioni" data-testid="reviews-section" className="relative bg-carbon py-20 md:py-28">
      <div className="mx-auto max-w-4xl px-6 text-center lg:px-8">
        <Reveal>
          <Overline className="justify-center">{t.reviews.overline}</Overline>
          <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-ice sm:text-4xl lg:text-5xl">
            {t.reviews.title}
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-dashed border-edge bg-asphalt/60 p-8" data-testid="reviews-placeholder">
            <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-edge text-amber">
              <ShieldQuestion className="h-6 w-6" />
            </span>
            <div className="mb-4 flex justify-center gap-1 text-steel/40" aria-hidden="true">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="h-5 w-5" fill="currentColor" />
              ))}
            </div>
            <p className="text-sm leading-relaxed text-steel">{t.reviews.placeholder}</p>
            {company.googleBusiness && company.googleBusiness !== "#" && (
              <a
                href={company.googleBusiness}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-google-link"
                className="mt-6 inline-flex items-center gap-2 rounded-md bg-amber px-6 py-3 font-display text-sm font-bold uppercase tracking-wide text-carbon transition-colors hover:bg-amber/90 active:scale-95"
              >
                {t.common.readAllReviews} <ExternalLink className="h-4 w-4" />
              </a>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
